<ng-container [ngSwitch]="column.type">
  <span *ngSwitchCase="'boolean'">
    <kendo-switch
      [disabled]="disabled"
      *ngIf="dataItem.originalValues.get(column.field) !== null"
      [style.height.px]="32 * fontSize"
      size="small"
      [checked]="dataItem[column.field] == true"
      (valueChange)="dataItem[column.field] = $event; onValueChange()"
    ></kendo-switch>

    <app-tri-state-switch
      [disabled]="disabled"
      *ngIf="dataItem.originalValues.get(column.field) === null"
      [style.height.px]="32 * fontSize"
      size="small"
      [value]="dataItem[column.field]"
      (valueChange)="dataItem[column.field] = $event; onValueChange()"
    ></app-tri-state-switch>
  </span>
  <span *ngSwitchCase="'number'">
    <kendo-numerictextbox
      [placeholder]="placeholder"
      [disabled]="disabled"
      disableMouseWheel
      [style.fontSize.rem]="fontSize"
      [spinners]="false"
      [style.height.px]=""
      (valueChange)="onValueChange()"
      [ngClass]="{
        warning: dataItem.warnings?.has(column.field),
        error: dataItem.errors?.has(column.field),
      }"
      [step]="0.1"
      [(ngModel)]="dataItem[column.field]"
    >
      <ng-template kendoSuffixTemplate>
        <span
          *ngIf="
            dataItem.dirty?.has(column.field) &&
            dataItem.dirty.get(column.field)
          "
          kendoTooltip
        >
          <fa-icon
            class="m-r-2"
            [title]="'You have unsaved changes'"
            [icon]="['fas', 'pen']"
          >
          </fa-icon>
        </span>
      </ng-template>
    </kendo-numerictextbox>
  </span>
  <span *ngSwitchCase="'date'">
    <kendo-datetimepicker
      [disabled]="disabled"
      [style.fontSize.rem]="fontSize"
      [style.height.rem]="2 * fontSize"
      (valueChange)="onValueChange()"
      [ngClass]="{
        warning: dataItem.warnings?.has(column.field),
        error: dataItem.errors?.has(column.field),
      }"
      [(ngModel)]="dataItem[column.field]"
    >
      <span
        *ngIf="
          dataItem.dirty?.has(column.field) && dataItem.dirty.get(column.field)
        "
        kendoTooltip
      >
        <fa-icon
          class="m-r-2"
          [title]="'You have unsaved changes'"
          [icon]="['fas', 'pen']"
        >
        </fa-icon>
      </span>
    </kendo-datetimepicker>
  </span>
  <span *ngSwitchDefault>
    <textarea
      [placeholder]="placeholder"
      [disabled]="disabled"
      [style.fontSize.rem]="fontSize"
      [style.height.rem]="2 * fontSize"
      kendoTextArea
      [(ngModel)]="dataItem[column.field]"
      [ngClass]="{
        warning: dataItem.warnings?.has(column.field),
        error: dataItem.errors?.has(column.field),
      }"
      (valueChange)="onValueChange()"
    ></textarea>
  </span>
</ng-container>

<span *ngIf="dataItem.errors?.has(column.field)" kendoTooltip>
  <fa-icon
    [title]="dataItem.errors?.get(column.field)"
    class="error"
    [icon]="['fas', 'exclamation-circle']"
  ></fa-icon>
</span>

<span *ngIf="dataItem.warnings?.has(column.field)" kendoTooltip>
  <fa-icon
    kendoTooltip
    [title]="dataItem.warnings?.get(column.field)"
    class="warning"
    [icon]="['fas', 'exclamation-circle']"
  ></fa-icon>
</span>
